export interface NewsletterConfig {
  provider: string;
  formActionUrl: string;
  formId: string;
}

interface NewsletterEnv {
  VITE_NEWSLETTER_PROVIDER?: string;
  VITE_CONVERTKIT_FORM_ACTION_URL?: string;
  VITE_CONVERTKIT_FORM_ID?: string;
}

export function getNewsletterConfig(
  env: NewsletterEnv = import.meta.env as NewsletterEnv,
): NewsletterConfig {
  return {
    provider: env.VITE_NEWSLETTER_PROVIDER || 'manual',
    formActionUrl: env.VITE_CONVERTKIT_FORM_ACTION_URL || '',
    formId: env.VITE_CONVERTKIT_FORM_ID || '',
  };
}

export function canSubmitNewsletter(config: NewsletterConfig) {
  return Boolean(config.formActionUrl);
}
